import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ConsentementComponent} from "./consentement/consentement.component";
import {ErrorComponent} from "./error/error.component";
import {CompleteComponent} from "./complete/complete.component";
import {LoginComponent} from "./login/login.component";

const routes: Routes = [
  // Route pour le composant Complete qui accepte des paramètres de requête (query parameters)
  {
    path: 'complete',
    component: CompleteComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: ':group',  // Paramètre de route à la racine
    children: [
      {path: '', redirectTo: 'login', pathMatch: 'full'}, // Redirection de /group vers /group/login
      {path: 'login', component: LoginComponent},
      {path: 'consentement', component: ConsentementComponent},
      {path: 'error', component: ErrorComponent},
      {path: '**', redirectTo: 'error'}
    ],
  },
  // Route par défaut
  {path: '', redirectTo: 'error', pathMatch: 'full'},
  {path: '**', redirectTo: 'error'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
